<div class="learn-more-modal">
  <div class="learn-more-modal__header">
    <h1>
      {{ '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.LEARN_MORE.TITLE' | translate }}
    </h1>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="learn-more-modal__content">
    <section>
      <h3>
        {{
          '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.LEARN_MORE.SECTION1_TITLE'
            | translate
        }}
      </h3>
      <p>
        {{
          '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.LEARN_MORE.SECTION1_TEXT'
            | translate
        }}
      </p>
    </section>

    <section>
      <h3>
        {{
          '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.LEARN_MORE.SECTION2_TITLE'
            | translate
        }}
      </h3>
      <div
        [innerHTML]="
          '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.LEARN_MORE.SECTION2_TEXT'
            | translate
        "
      ></div>
    </section>

    <section>
      <h3>
        {{
          '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.LEARN_MORE.SECTION3_TITLE'
            | translate
        }}
      </h3>
      <p>
        {{
          '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.LEARN_MORE.SECTION3_TEXT'
            | translate
        }}
      </p>
    </section>
  </div>

  <div class="learn-more-modal__footer">
    <button mat-stroked-button (click)="close()">
      {{ '+INSTALLATIONS.INSTALLATION.OVERLAY.CLOSE_BUTTON' | translate }}
    </button>
  </div>
</div>
